import type { MockupDef } from "../types/configurator";

// Zones are expressed in the 400 × 400 coordinate space of each mockup drawing.
export const mockups: MockupDef[] = [
  {
    id: "tshirt",
    zones: [
      { id: "face", name: "Face avant", view: "front", x: 142, y: 124, w: 116, h: 150 },
      { id: "coeur", name: "Cœur", view: "front", x: 222, y: 112, w: 44, h: 44 },
      { id: "manche", name: "Manche", view: "front", x: 62, y: 124, w: 32, h: 32 },
      { id: "dos", name: "Dos", view: "back", x: 136, y: 100, w: 128, h: 180 },
    ],
  },
  {
    id: "hoodie",
    zones: [
      { id: "face", name: "Face avant", view: "front", x: 136, y: 168, w: 128, h: 96 },
      { id: "dos", name: "Dos", view: "back", x: 130, y: 130, w: 140, h: 170 },
    ],
  },
  {
    id: "cap",
    zones: [
      { id: "face", name: "Face avant", view: "front", x: 150, y: 128, w: 100, h: 72 },
      { id: "cote", name: "Côté", view: "front", x: 104, y: 176, w: 36, h: 36 },
      { id: "arriere", name: "Arrière", view: "back", x: 160, y: 140, w: 80, h: 46 },
    ],
  },
  {
    id: "tote",
    zones: [
      { id: "face", name: "Face avant", view: "front", x: 122, y: 180, w: 156, h: 150 },
      { id: "verso", name: "Face arrière", view: "back", x: 122, y: 180, w: 156, h: 150 },
    ],
  },
  {
    id: "backpack",
    zones: [
      { id: "face", name: "Poche avant", view: "front", x: 142, y: 252, w: 116, h: 78 },
      { id: "rabat", name: "Rabat", view: "front", x: 150, y: 94, w: 100, h: 56 },
    ],
  },
  {
    id: "mug",
    zones: [
      { id: "face", name: "Face avant", view: "front", x: 130, y: 150, w: 120, h: 160 },
      { id: "verso", name: "Face arrière", view: "back", x: 150, y: 150, w: 120, h: 160 },
    ],
  },
  {
    id: "bottle",
    zones: [
      { id: "face", name: "Face avant", view: "front", x: 146, y: 190, w: 108, h: 140 },
      { id: "verso", name: "Face arrière", view: "back", x: 146, y: 190, w: 108, h: 140 },
    ],
  },
  {
    id: "notebook",
    zones: [
      { id: "couverture", name: "Couverture", view: "front", x: 140, y: 110, w: 140, h: 170 },
      { id: "dos", name: "4e de couverture", view: "back", x: 140, y: 260, w: 140, h: 56 },
    ],
  },
  {
    id: "pen",
    zones: [
      { id: "corps", name: "Corps", view: "front", x: 110, y: 183, w: 170, h: 34 },
      { id: "clip", name: "Clip", view: "front", x: 72, y: 159, w: 96, h: 12 },
    ],
  },
  {
    id: "box",
    zones: [
      { id: "couvercle", name: "Couvercle", view: "front", x: 90, y: 118, w: 220, h: 40 },
      { id: "face", name: "Face avant", view: "front", x: 100, y: 190, w: 200, h: 110 },
    ],
  },
  {
    id: "card",
    zones: [
      { id: "face", name: "Face avant", view: "front", x: 112, y: 150, w: 176, h: 100 },
      { id: "dos", name: "Dos", view: "back", x: 112, y: 150, w: 176, h: 100 },
    ],
  },
  {
    id: "round",
    zones: [
      { id: "cadran", name: "Cadran", view: "front", x: 140, y: 218, w: 120, h: 50 },
      { id: "dos", name: "Dos", view: "back", x: 130, y: 140, w: 140, h: 120 },
    ],
  },
  {
    id: "flat",
    zones: [{ id: "face", name: "Face avant", view: "front", x: 105, y: 108, w: 190, h: 170 }],
  },
];
